:root {
  color-scheme: dark;
  --space-950: #05070d;
  --space-900: #0a101c;
  --panel: rgba(12, 17, 28, 0.92);
  --text: #e9eef7;
  --muted: #94a3bb;
  --accent: #9cc3f0;
  --sun: #f5b84b;
  --ecliptic: #70a9c7;
  --lunar-plane: #77c7ba;
  --equatorial: #b8a7d8;
  --focus: #ffd36a;
  --touch-target: 44px;
  --panel-opaque: #0d1420;
  --line: rgb(148 163 187 / 0.28);
  --line-strong: rgb(148 163 187 / 0.5);
  --font-display: "Space Grotesk", "Avenir Next", "Segoe UI", sans-serif;
  --font-sans: "Inter", "Avenir Next", "Segoe UI", Helvetica, sans-serif;
  --space-1: 0.5rem;
  --space-2: 1rem;
  --space-3: 1.5rem;
  --space-4: 2rem;
  --content-measure: 82rem;
  --motion-duration: 160ms;
  --color-background: var(--space-950);
  --color-surface: var(--panel);
  --color-text: var(--text);
  --color-text-muted: var(--muted);
  --color-accent: var(--accent);
}

*:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  :root {
    --motion-duration: 0ms;
  }

  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0ms !important;
    animation-duration: 0ms !important;
    animation-iteration-count: 1 !important;
  }
}
